import {useUnit} from 'effector-react';
import {useEffect} from 'react';
import {
  $ideasStore,
  fetchIdeasRequested,
  fetchMyIdeasRequested,
  fetchMyIdeasPublishedRequested,
  fetchMyIdeasDraftsRequested,
  fetchMyIdeasArchivedRequested,
  loadMoreIdeasRequested,
  updateIdeaBookmark,
} from '../store';
import {IdeasFilter, IdeasFilters} from '../model/types';

export const useIdeasViewModel = () => {
  const {
    ideas,
    ideasPublished,
    ideasDrafts,
    ideasArchived,
    loading,
    loadMore,
    error,
    pagination,
    allIdeasCount,
    totalIdiasCount,
  } = useUnit($ideasStore);

  // Fetch ideas on mount
  useEffect(() => {
    fetchIdeasRequested({filters: {}, type: null});
  }, []);

  const getFilteredIdeas = (filter: IdeasFilter) => {
    // Since we're now fetching the correct data from API, just return all ideas
    return ideas;
  };

  const getPublishedIdeas = () => {
    return ideasPublished;
  };

  const getDraftIdeas = () => {
    return ideasDrafts;
  };

  const getArchivedIdeas = () => {
    return ideasArchived;
  };

  const getPublishedIdeasCount = () => {
    return ideasPublished.length;
  };

  const getDraftIdeasCount = () => {
    return ideasDrafts.length;
  };

  const getArchivedIdeasCount = () => {
    return ideasArchived.length;
  };

  const getAllIdeasCount = () => {
    return allIdeasCount;
  };

  const getTotalIdeasCount = () => {
    return totalIdiasCount;
  };

  const fetchIdeasWithFilters = (filters: IdeasFilters, filterType?: IdeasFilter) => {
    if (filterType === 'my-ideas') {
      fetchMyIdeasRequested(filters);
    } else {
      fetchIdeasRequested({filters, type: null});
    }
  };

  const fetchPublishedIdeas = (filters?: IdeasFilters) => {
    fetchMyIdeasPublishedRequested(filters);
  };

  const fetchDraftIdeas = (filters?: IdeasFilters) => {
    fetchMyIdeasDraftsRequested(filters);
  };

  const fetchArchivedIdeas = (filters?: IdeasFilters) => {
    fetchMyIdeasArchivedRequested(filters);
  };

  const loadMoreIdeasWithFilters = (filters: IdeasFilters) => {
    loadMoreIdeasRequested(filters);
  };

  const hasMoreIdeas = () => {
    return pagination.page * 24 < pagination.total;
  };

  const updateBookmark = ({ideaId, isBookmarked}: {ideaId: string; isBookmarked: boolean}) => {
    updateIdeaBookmark({ideaId, isBookmarked});
  };

  return {
    ideas,
    ideasPublished,
    ideasDrafts,
    ideasArchived,
    loading,
    loadMore,
    error,
    getFilteredIdeas,
    getPublishedIdeas,
    getDraftIdeas,
    getArchivedIdeas,
    getAllIdeasCount,
    getTotalIdeasCount,
    getPublishedIdeasCount,
    getDraftIdeasCount,
    getArchivedIdeasCount,
    fetchIdeasWithFilters,
    fetchPublishedIdeas,
    fetchDraftIdeas,
    fetchArchivedIdeas,
    loadMoreIdeasWithFilters,
    hasMoreIdeas,
    updateBookmark,
  };
};
